// extracted by mini-css-extract-plugin
export var container = "member-list-module--container--IrtWd";
export var wrapper = "member-list-module--wrapper--3uKhK";
export var title = "member-list-module--title--1ZCsg";
export var studentItems = "member-list-module--studentItems--g-X45";
export var studentItem = "member-list-module--studentItem--1hZIL";
export var studentItemImg = "member-list-module--studentItemImg--p1CCg";
export var studentName = "member-list-module--studentName--CA3FO";
export var studentDesc = "member-list-module--studentDesc--3K-My";
export var graduate = "member-list-module--graduate--2caKB";